import { isInteger } from 'lodash';
import { IValidatorFactoryService } from './validator-factory.service';
import { IValidatorFn } from '../../../interfaces/IValidatorFn';
import { shellStringResources } from '../../../Resources/ShellStringResources';
import { IIntegerMetadata } from '../../metadatas/validator/integer-metadata';

export class IntegerValidatorFactoryService implements IValidatorFactoryService<IIntegerMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'integer';

    public createValidatorByMetadata(metadata: IIntegerMetadata): IValidatorFn {
        return this.createValidator(metadata.min, metadata.max, metadata.errorMessage);
    }
    public createValidator(min: number = -Number.MAX_VALUE, max: number = Number.MAX_VALUE, errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : shellStringResources.Validator_ErrorMessage_Integer;
        return (value: number) => {
            return (isInteger(+value) && (value >= min) && (value <= max)) ? null : errorMessage;
        };
    }
}
